import React, { useState } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import {
  useHubEvent,
  useTriggerNotificationsRefetch,
} from "../../../context/NotificationHubContext";

const TOAST_BY_STATUS = {
  Completed: {
    severity: "success",
    message: "Your CRB monthly report is ready — check your email.",
  },
  Failed: {
    severity: "error",
    message: "Your CRB monthly report failed to generate — check your email or try again.",
  },
};

// Mounted once, app-wide (see App.js), so the report-ready toast and Topbar
// bell refresh fire no matter what page the user is currently on — unlike
// useCrbMonthlyReport's own subscription, which only exists while the
// report-browser card is mounted.
const CrbMonthlyReportGlobalListener = () => {
  const [toast, setToast] = useState(null);
  const triggerNotificationsRefetch = useTriggerNotificationsRefetch();

  useHubEvent("ReportReady", (payloadJson) => {
    const payload = JSON.parse(payloadJson);
    triggerNotificationsRefetch();

    const toastConfig = TOAST_BY_STATUS[payload.status];
    if (toastConfig) {
      setToast(toastConfig);
    }
  });

  return (
    <Snackbar
      open={!!toast}
      autoHideDuration={10000}
      onClose={() => setToast(null)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={(props) => <Slide {...props} direction="left" />}
    >
      {toast && (
        <Alert onClose={() => setToast(null)} severity={toast.severity} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      )}
    </Snackbar>
  );
};

export default CrbMonthlyReportGlobalListener;
